import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const SSNInputWithEncryption = ({ label = 'SSN', error }) => {
  const [ssn, setSSN] = useState('');
  const [showDecrypted, setShowDecrypted] = useState(true);

  const handleToggleVisibility = () => {
    setShowDecrypted((prev) => !prev);
  };

  const handleSSNChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    if (rawValue.length <= 9) {
      setSSN(rawValue);
    }
  };

  const formatSSN = (digits) => {
    const match = digits.match(/^(\d{0,3})(\d{0,2})(\d{0,4})$/);
    if (!match) return '';
    const [, part1, part2, part3] = match;
    let result = '';
    if (part1) result += part1;
    if (part2) result += '-' + part2;
    if (part3) result += '-' + part3;
    return result;
  };

  const getDisplayedValue = () => {
    return showDecrypted
      ? formatSSN(ssn)
      : ssn.length === 9
        ? '***-**-****'
        : '';
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={!!error}
      required
    >
      <InputLabel htmlFor="ssn-input">{label}</InputLabel>
      <OutlinedInput
        id="ssn-input"
        label={label}
        value={getDisplayedValue()}
        onChange={handleSSNChange}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle ssn visibility"
              onClick={handleToggleVisibility}
              edge="end"
            >
              {showDecrypted ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SSNInputWithEncryption;
